// Core
import useSWR from "swr";

// Definitions
import { GameInitRequestType, GameInitType } from "@/domains/games/types";
import {
  HttpResponseAxiosDataType,
  HttpResponseAxiosErrorType,
  ServerErrorBaseType,
} from "@/types/http";

// Utils
import { gamesApi } from "@/domains/games/service";
import { gamesKeys } from "@/domains/games/apiKeys";
import { log } from "@/utils/browser-logger";

type UseGameDemoInitType = ({ gameId, demo }: { gameId?: string; demo: boolean }) => {
  loadingGameDemoInit: boolean;
  gameDemoUrl: string;
  onMutateGameDemoInit: () => void;
  errorGameDemoInit?: ServerErrorBaseType;
};

const fetcher = (key: [string, GameInitRequestType]) => {
  const [, data] = key;

  return gamesApi.initGameDemo({ data });
};

export const useGameDemoInit: UseGameDemoInitType = (payload) => {
  const { gameId, demo } = payload;

  const shouldFetch = gameId && demo;
  const key = shouldFetch ? [gamesKeys.demoInitGame, payload] : null;

  const { data, isLoading, isValidating, mutate, error } = useSWR<
    HttpResponseAxiosDataType<GameInitType>,
    HttpResponseAxiosErrorType
  >(key, fetcher, {
    revalidateOnMount: false, // чтобы не вызывался сразу
    revalidateOnFocus: false, // чтобы не триггерилось при фокусе
    shouldRetryOnError: false,
    onError: (err) => {
      try {
        const status = err.response?.status;
        if (status >= 400 && status < 600) {
          log.crucial(err.message);
        }
      } catch (e) {
        log.crucial(err.message);
      }
    },
  });

  const onMutateGameDemoInit = () => {
    return void mutate(void 0, { revalidate: true });
  };

  return {
    loadingGameDemoInit: isLoading || isValidating,
    gameDemoUrl: data?.data.url || "",
    onMutateGameDemoInit,
    errorGameDemoInit: error?.response?.data,
  };
};
